import { api } from "services"

export async function getCompanies() {
  const { data } = await api.get("/companies?asList=1")
  
  return data
}